/**
 * billing_toggle_controller.js — monthly/annual price swap (Stimulus).
 *
 * Element-scoped controller for the pricing page's billing switch. One instance
 * per pricing section (data-controller="billing-toggle"). The checkbox carries
 * data-action="change->billing-toggle#swap"; on change it swaps the textContent
 * of every .price-amount / .price-period / .price-note inside this.element from
 * its data-monthly to its data-annual attribute (or back).
 *
 * Replaces an inline <script> that bound the toggle via getElementById — which
 * breaks after a Turbo navigation. Stimulus re-connects automatically after each
 * <body> swap and auto-removes the action listener on disconnect, so no manual
 * lifecycle bookkeeping is needed. The page is turbo-cache-control:no-cache, so
 * the server always re-renders the monthly default; no snapshot revert required.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        swap(event) {
            var period = event.target.checked ? 'annual' : 'monthly';
            this.element.querySelectorAll('.price-amount, .price-period, .price-note')
                .forEach(function (el) { el.textContent = el.dataset[period]; });
        }
}
